import AtlasSdk from '@atlas/sdk';

import { Name, AttributeMap } from './event';

class ErrorReporterClient {
  notify(error: Error, attributes?: Record<string, unknown>) {
    if (AtlasSdk && AtlasSdk.monitoring) {
      AtlasSdk.monitoring.report(error, {
        type: 'Warning',
        app: 'case-management-ui',
        ...attributes,
      });
      // eslint-disable-next-line no-console
    } else console.warn(`The NR monitoring client has not been initialized`);
  }

  addPageAction<T extends Name>(name: T, attributes: AttributeMap[T]) {
    if (!(AtlasSdk && AtlasSdk.monitoring)) {
      // eslint-disable-next-line no-console
      console.warn(`The NR monitoring client has not been initialized`);
      return;
    }
    AtlasSdk.monitoring.dispatch(name, attributes);
  }
}

const errorReporterClient = new ErrorReporterClient();
export default errorReporterClient;
